export default {
  props: {
    option: Object,
    /**
     * 自定义属性
     * */
    customProps: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  render(h) {
    // 用递归方式查找父组件，直到找到 TransferPanel 组件
    const getParent = vm => {
     
      if (vm.$options.name === 'TransferPanel') {
        return vm;
      } else if (vm.$parent) {
        return getParent(vm.$parent);
      } else {
        return vm;
      }
    };

    // 获取 TransferPanel 实例
    const panel = getParent(this);

    // 获取 TransferPanel 的父组件或自身作为 transfer
    const transfer = panel.$parent || panel;

    // 如果 panel 有 renderContent 方法，优先调用它
    if (panel.renderContent) {
     
      return panel.renderContent(h, this.option, this.customProps);
    }

    // 如果 transfer 组件有 default 插槽，使用它来渲染内容
    if (transfer.$scopedSlots && transfer.$scopedSlots.default) {
      return transfer.$scopedSlots.default({ option: this.option,customProps: this.customProps });
    }

    // 默认显示 option 的 label 或 key 值
    return h('span', this.option[panel.labelProp] || this.option[panel.keyProp]);
  }
};